import { FileDocument } from '@ivymobi/orbit-core';
import { getJSON, postJSON } from '../api';

type DocumentsByAIArgs = [
  url: string,
  token: string
];

export function getDocumentsByAIargs(
  props: { tid: string, astId: string[], token?: string }
): DocumentsByAIArgs {
  const { tid, astId, token } = props;
  if (astId.length === 0) {
    return null;
  }

  const baseUrl = `tenants/${tid}/selExtDocumentsByastId`;
  const params = new URLSearchParams();
  astId.forEach((id, index) => params.append(`astId[${index}]`, id));
  const url = `${baseUrl}?${params.toString()}`;
  return [url, token];
}
export async function getDocumentsByAI(
  args: DocumentsByAIArgs
): Promise<FileDocument[]> {
  const [url, token] = args;

  try {
    const res = await getJSON<FileDocument[]>({
      url,
      ...(token && {token})
    });
    return res;
  } catch (err) {
    console.error(err);
  }
}